import { testimonials } from "@/data/portfolioData";

export function Testimonials() {
  return (
    <section className="relative z-[2] px-6 pb-[70px] pt-8 md:px-14">
      <p className="mb-1.5 text-center text-base font-bold text-teal">Kind words</p>
      <h2 className="mb-11 text-center font-display text-[44px] text-ink">Testimonials</h2>

      <div className="work-grid grid grid-cols-1 gap-6 md:grid-cols-3">
        {testimonials.map((item) => (
          <article
            key={item.name}
            className={`neo-card neo-card-hover rounded-[18px] p-7 ${item.color}`}
          >
            <p
              className={`mb-[18px] text-base leading-relaxed ${
                item.textDark ? "text-ink" : "text-white"
              }`}
            >
              &ldquo;{item.quote}&rdquo;
            </p>
            <p
              className={`m-0 font-display text-[15px] ${
                item.textDark ? "text-ink" : "text-white"
              }`}
            >
              {item.name}
            </p>
            <p
              className={`mt-0.5 text-[13px] ${
                item.textDark ? "text-[#4A4A2A] opacity-70" : "text-[#FBE0E5]"
              }`}
            >
              {item.role}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
